import { ObjectSchema } from '@framework/validation';
import { ISerializedFormSectionValue } from './ISerializedFormSectionValue';
import { serializeFormValues } from './serializeFormValues';

/**
 * Serializza e mappa i valori delle sezioni in un formato compatibile con l'API
 */
// TODO Aggiungere sessione
export function serializeFormSectionsValues(
  validationSchema: ObjectSchema<any>,
  values: Record<string, any>,
): ISerializedFormSectionValue[] {
  const serializedValues = serializeFormValues(validationSchema, values);

  return (
    serializedValues.values?.map(v => ({
      // Non dovrebbe mai essere undefined, ma per sicurezza e per evitare errori di tipi lo gestiamo
      idSezione: v?.name ?? '<undefined>',
      valori: v,
    })) ?? []
  );
}
